import { TabPane } from 'reactstrap'
import AppObjectHistoryTable from '../AppObjectHistoryTable/AppObjectHistoryTable'

export default function AppObjectHistoryPane({ history }) {
  console.log('AppObjectHistoryPane rendered')

  return (
    <TabPane className="app-object-tab-pane" tabId='history'>
      <AppObjectHistoryTable history={history} />
    </TabPane>
  )
}